import { Stack } from "@mui/material";
import type { ReactNode } from "react";

// Lines the content up with the header, which is 92 % wide and centered.
const PAGE_PADDING_X = "4%";

export const PdfTemplatePage = ({ children }: { children: ReactNode }) => <Stack px={PAGE_PADDING_X}>{children}</Stack>;
